const TestPageActionTypes = {
	START_ATTEMPT: {
		PENDING: 'START_ATTEMPT_PENDING',
		SUCCESS: 'START_ATTEMPT_SUCCESS',
		FAILURE: 'START_ATTEMPT_FAILURE',
	},
	FETCH_ATTEMPT: {
		SUCCESS: 'FETCH_ATTEMPT_TEST_PAGE_SUCCESS',
		FAILURE: 'FETCH_ATTEMPT_TEST_PAGE_FAILURE',
		PENDING: 'FETCH_ATTEMPT_TEST_PAGE_PENDING',
	},
	SUBMIT_FEEDBACK: {
		SUCCESS: 'SUBMIT_FEEDBACK_SUCCESS',
		FAILURE: 'SUBMIT_FEEDBACK_FAILURE',
		PENDING: 'SUBMIT_FEEDBACK_PENDING',
	},
	SUBMIT_ANSWER: {
		SUCCESS: 'SUBMIT_ANSWER_SUCCESS',
		FAILURE: 'SUBMIT_ANSWER_FAILURE',
		PENDING: 'SUBMIT_ANSWER_PENDING',
	},
	TOGGLE_SUBMIT_ACTIVE: 'TOGGLE_SUBMIT_ACTIVE',
	SHOW_THANKYOU_MODAL: 'SHOW_THANKYOU_MODAL',
	SET_CURRENT_ATTEMPT_ID: 'SET_CURRENT_ATTEMPT_ID',
	TOGGLE_FEEDBACK: 'TOGGLE_FEEDBACK',
	SET_PREV_VIDEO_ID: 'SET_PREV_VIDEO_ID',
	SET_INITIAL_TEST_DETAILS: 'SET_INITIAL_TEST_DETAILS',
	UPDATE_RESET_COUNTER: 'UPDATE_RESET_COUNTER',
	TOGGLE_MIC_PERMISSION: 'TOGGLE_MIC_PERMISSION',
	RESET_TEST_DATA: 'RESET_TEST_DATA',
	SET_SHOW_REVIEW: 'SET_SHOW_REVIEW',
	SET_SHOW_THANK_YOU: 'SET_SHOW_THANK_YOU',
	CHECK_VIDEO: {
		SUCCESS: 'CHECK_VIDEO_SUCCESS',
		FAILURE: 'CHECK_VIDEO_FAILURE',
		PENDING: 'CHECK_VIDEO_PENDING',
	},
};

export default TestPageActionTypes;
